module.exports = __webpack_public_path__ + "img/right.c7d37890.png";